import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Components/Button';

const ThankYou = () => {
    return (
        <section className='bg-gableGreen flex flex-col items-center justify-center min-h-screen px-6 sm:px-10 xl:px-59 py-12 md:py-16 xl:py-24 2xl:py-28'>
            <div className='w-full max-w-830 mx-auto text-center'>
                {/* Success Icon */}
                <div className='mb-8 sm:mb-12'>
                    <div className='w-20 h-20 sm:w-24 sm:h-24 lg:w-28 lg:h-28 mx-auto bg-honeysuckle rounded-full flex items-center justify-center'>
                        <svg
                            className='w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 text-gableGreen'
                            fill='currentColor'
                            viewBox='0 0 20 20'
                        >
                            <path
                                fillRule='evenodd'
                                d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                clipRule='evenodd'
                            />
                        </svg>
                    </div>
                </div>

                {/* Main Heading */}
                <h1 className='font-tobias text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-honeysuckle mb-6 sm:mb-8'>
                    Thank You!
                </h1>

                {/* Subheading */}
                <h2 className='font-tobias text-xl sm:text-2xl lg:text-3xl text-honeysuckle mb-6 sm:mb-8'>
                    Your submission has been received
                </h2>

                {/* Message */}
                <div className='mb-8 sm:mb-12'>
                    <p className='font-mori text-base sm:text-lg lg:text-xl text-honeysuckle leading-relaxed mb-4'>
                        Thank you for your interest in Banyan Hill. A member of our team will be in touch with you shortly to discuss your enquiry.
                    </p>
                    <p className='font-mori text-sm sm:text-base lg:text-lg text-polar leading-relaxed'>
                        In the meantime, feel free to explore more about our community and what makes Banyan Hill special.
                    </p>
                </div>

                {/* Contact Information */}
                <div className='bg-honeysuckle bg-opacity-20 rounded-lg p-6 sm:p-8 mb-8 sm:mb-12 border border-honeysuckle border-opacity-30'>
                    <h3 className='font-tobias text-lg sm:text-xl lg:text-2xl text-honeysuckle mb-4'>
                        Need immediate assistance?
                    </h3>
                    <div className='flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8'>
                        <div className='text-center'>
                            <p className='font-mori text-sm lg:text-base text-polar font-medium mb-1'>
                                Call us
                            </p>
                            <a
                                href='tel:1300326197'
                                className='font-mori text-lg sm:text-xl font-bold text-honeysuckle hover:text-polar transition-colors duration-200'
                            >
                                1300 326 197
                            </a>
                        </div>
                        <div className='text-center'>
                            <p className='font-mori text-sm lg:text-base text-polar font-medium mb-1'>
                                Email us
                            </p>
                            <a
                                href='mailto:info@banyanhill.com.au'
                                className='font-mori text-base sm:text-lg font-bold text-honeysuckle hover:text-polar transition-colors duration-200'
                            >
                                info@banyanhill.com.au
                            </a>
                        </div>
                    </div>
                </div>

                                {/* Action Buttons */}
                <div className='flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6'>
                                        <Link to='/'>
                        <Button
                            title='Return to Home'
                            variant='honeysuckle'
                            className='w-full sm:w-auto px-8 py-3 text-base sm:text-lg'
                        />
                    </Link>
                    <Link to='/masterplan'>
                        <Button
                            title='View Masterplan'
                            variant='honeysuckle'
                            className='w-full sm:w-auto px-8 py-3 text-base sm:text-lg'
                        />
                    </Link>
                    <Link to='/the-life'>
                        <Button
                            title='Explore The Life'
                            variant='honeysuckle'
                            className='w-full sm:w-auto px-8 py-3 text-base sm:text-lg'
                        />
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ThankYou;